import { useEffect, useState } from 'react';

import {
  SCREEN_LG,
  SCREEN_MD,
  SCREEN_SM,
  SCREEN_XL,
  SCREEN_XXL,
} from '../constants/common';

export const useResize = () => {
  // Keep the initial server and client renders identical; read the viewport
  // only after hydration in the effect below.
  const [width, setWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => setWidth(window.innerWidth);
    setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    width,
    isScreenSm: width !== undefined && width <= SCREEN_SM,
    isScreenMd: width !== undefined && width <= SCREEN_MD,
    isScreenLg: width !== undefined && width <= SCREEN_LG,
    isScreenXl: width !== undefined && width <= SCREEN_XL,
    isScreenXxl: width !== undefined && width <= SCREEN_XXL,
  };
};
